import axios from "axios";
import { io } from "socket.io-client";

export default function startAviatorGame() {
  const base_url = process.env.REACT_APP_API_URL;
  const socket = io(base_url, {
    auth: {
      token: localStorage.getItem("token"),
    },
  });

  let planeX = 0;
  let planeY = 0;
  let userData = {};

  /*************************
   * GAME STATES
   *************************/
  const GAME_STATE = {
    IDLE: "IDLE",
    LOADING: "LOADING",
    FLYING: "FLYING",
    CRASHED: "CRASHED",
  };

  let gameId = null;

  let serverMultiplier = 1;
  let serverGameState = GAME_STATE.IDLE;

  let gameState = serverGameState;

  let isBet1Active = false;
  let isBet2Active = false;
  let isBet1Placed = false;
  let isBet2Placed = false;

  // ------------------- GAME ELEMENTS -------------------
  const canvas = document.getElementById("gameCanvas");
  const ctx = canvas.getContext("2d");

  const multDisplay = document.getElementById("multiplier");
  const multSpanEl = document.querySelector("#multiplier .multSpan");
  const flewAwayEl = document.querySelector("#multiplier .flew-away");

  const timerModal = document.getElementById("timer-modal");
  const actionBtn1 = document.getElementById("actionBtn1");
  const actionBtn2 = document.getElementById("actionBtn2");
  const autoBtn1 = document.getElementById("btnAutoBet1");
  const autoBtn2 = document.getElementById("btnAutoBet2");
  const loadBar = document.getElementById("loading-bar");

  const historyWrapper = document.getElementById("historyWrapper");
  const historyBar = document.getElementById("historyBar");
  const historyMore = document.getElementById("historyMore");
  const historyClose = document.getElementById("historyClose");

  const totalWinValue = document.querySelector(".total-win-value");

  const allBetsBtn = document.getElementById("allBetsBtn");
  const previousBtn = document.getElementById("previousBtn");
  const topWinnerBtn = document.getElementById("topWinnerBtn");

  const betList = document.getElementById("betList");
  const topBetList = document.getElementById("topBetList");
  const animatedPlane = document.getElementById("animatedPlane");

  const backgroundAudio = document.getElementById("backgroundAudio");
  const planeStartAudio = document.getElementById("planeStartAudio");
  const planeCrashAudio = document.getElementById("planeCrashAudio");

  const btnBackgroundAudio = document.getElementById("btnBackgroundAudio");
  const btnPlaneStartAudio = document.getElementById("btnPlaneStartAudio");
  const btnPlaneCrashAudio = document.getElementById("btnPlaneCrashAudio");

  const avatarsContainer = document.querySelector("#usersCount .avatars");
  const avatarsContainerSidebar = document.querySelector(
    "#betStatsAvtars .avatars",
  );
  const countText = document.querySelector("#usersCount .count-text");
  const countLeftParticipant = document.getElementById("leftBetParticipant");
  const countTotalParticipant = document.getElementById("totalBetParticipant");

  const betContainer = document.querySelector(".bet-stats-container");
  const bettingSidebar = document.querySelector(".betting-sidebar");

  const sidebar = document.getElementById("sidebar");
  const openBtn = document.getElementById("openProfileSidebar");

  // Bet tabs containers
  const betTabs1 = "betTabs1";
  const betPanel1 = "betPanel1";
  const autoPanel1 = "autoPanel1";

  const betTabs2 = "betTabs2";
  const betPanel2 = "betPanel2";
  const autoPanel2 = "autoPanel2";

  const avatars = Array.from({ length: 72 }, (_, i) => `av-${i + 1}.png`);
  let totalUsers = Math.floor(Math.random() * 1500);

  let prevMultiplier = 0;
  let totalWinAmount = 0;
  const historyData = [];
  let isExpanded = false;
  let multiplier = 1.0;
  let frame = 0;
  let flightT = 0;
  let flyX = 0,
    flyY = 0;
  let phaseStartFrame = 0;

  // Disco effect
  let discoRotation = 0,
    discoHue = 0;

  // let planeX = 0;
  // let planeY = 0;

  // let planeWidth = 180; // default width
  // let planeHeight = 60; // default height
  // const planeAspectRatio = 120 / 60; // original ratio

  let planeWidth = 180;
  let planeHeight = 60;

  const PLANE_MIN_WIDTH = 100; // 🔒 minimum size
  const PLANE_MAX_WIDTH = 150; // optional max
  const planeAspectRatio = 120 / 60;

  // Starting position
  const startX = 0;
  // const getStartY = () => canvas.height - 60;
  const getStartY = () => canvas.height - planeHeight;

  const betAmount1 = document.getElementById("betAmount1");
  const betAmount2 = document.getElementById("betAmount2");

  if (!betAmount1 || !betAmount2) {
    console.warn("Aviator engine waiting for inputs...");
    return;
  }

  const amount1 = parseFloat(betAmount1.value);
  const amount2 = parseFloat(betAmount2.value);

  /*************************
   * BET OBJECTS
   *************************/

  const bet1 = {
    placed: false,
    pending: false,
    round: false,
    auto: false,
    amount: 10,
    autoCashoutEnabled: false,
    autoCashoutValue: 0,
  };

  const bet2 = {
    placed: false,
    pending: false,
    round: false,
    auto: false,
    amount: 10,
    autoCashoutEnabled: false,
    autoCashoutValue: 0,
  };

  // function updatePlaneSize() {
  //   planeWidth = canvas.width * 0.15; // 10% of canvas width
  //   planeHeight = planeWidth / planeAspectRatio;

  //   animatedPlane.style.width = planeWidth + "px";
  //   animatedPlane.style.height = planeHeight + "px";
  // }

  function updatePlaneSize() {
    let responsiveWidth = canvas.width * 0.15;

    // 🔒 clamp width
    planeWidth = Math.max(
      PLANE_MIN_WIDTH,
      Math.min(responsiveWidth, PLANE_MAX_WIDTH),
    );

    planeHeight = planeWidth / planeAspectRatio;

    animatedPlane.style.width = planeWidth + "px";
    animatedPlane.style.height = planeHeight + "px";
  }

  function updateBetAmounts() {
    bet1.amount = parseFloat(betAmount1.value) || 0;
    bet2.amount = parseFloat(betAmount2.value) || 0;
  }

  // ------------------- UTILITY FUNCTIONS -------------------
  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }
  function lerp(a, b, t) {
    return a + (b - a) * t;
  }
  function crashRandom(edge = 0.01) {
    if (Math.random() < edge) return 1;
    const u = Math.random();
    return Math.min(Math.floor((1 / (1 - u * (1 - edge))) * 100) / 100, 10000);
  }

  function openSidebar() {
    sidebar.classList.add("open");
    document.body.style.overflow = "hidden"; // optional: prevent scroll behind
  }
  function toggleSidebar() {
    const currentRight = window.getComputedStyle(sidebar).right;

    if (currentRight === "0px") {
      sidebar.style.right = "-320px";
    } else {
      sidebar.style.right = "0px";
    }
  }

  openBtn.addEventListener("click", toggleSidebar);

  allBetsBtn.addEventListener("click", () => {
    // Only call if not already active
    if (!allBetsBtn.classList.contains("active")) {
      previousBtn.classList.remove("active");
      topWinnerBtn.classList.remove("active");
      allBetsBtn.classList.add("active");

      betList.style.display = "block";
      betContainer.style.display = "block";
      topBetList.style.display = "none";

      let previousRoundResult = document.querySelector(
        ".previous-round-result",
      );
      let filterDiv = document.querySelector(".filterDiv");
      if (previousRoundResult) {
        previousRoundResult.style.display = "none";
      }

      if (filterDiv) {
        filterDiv.style.display = "none";
      }

      let betHeader = document.querySelector(".bet-header");
      let roundHeader = document.querySelector(".round-header");

      if (betHeader) {
        betHeader.style.display = "flex";
      }

      if (roundHeader) {
        roundHeader.style.display = "none";
      }
      showAllBets();
    }
  });

  previousBtn.addEventListener("click", () => {
    // Only call if not already active
    if (!previousBtn.classList.contains("active")) {
      topWinnerBtn.classList.remove("active");
      allBetsBtn.classList.remove("active");
      previousBtn.classList.add("active");

      betContainer.style.display = "none";
      betList.style.display = "block";
      topBetList.style.display = "none";

      let previousRoundResult = document.querySelector(
        ".previous-round-result",
      );
      let filterDiv = document.querySelector(".filterDiv");
      if (previousRoundResult) {
        previousRoundResult.style.display = "none";
      }
      if (filterDiv) {
        filterDiv.style.display = "none";
      }

      let betHeader = document.querySelector(".bet-header");
      let roundHeader = document.querySelector(".round-header");

      if (betHeader) {
        betHeader.style.display = "flex";
      }

      if (roundHeader) {
        roundHeader.style.display = "none";
      }
      showPreviousBets();
    }
  });

  topWinnerBtn.addEventListener("click", () => {
    // Only call if not already active
    if (!topWinnerBtn.classList.contains("active")) {
      allBetsBtn.classList.remove("active");
      previousBtn.classList.remove("active");
      topWinnerBtn.classList.add("active");

      betList.style.display = "none";
      betContainer.style.display = "none";
      topBetList.style.display = "block";
      let previousRoundResult = document.querySelector(
        ".previous-round-result",
      );
      if (previousRoundResult) {
        previousRoundResult.style.display = "none";
      }
      showTopWinner();
    }
  });

  // =========================
  // 2. Setup Tabs Function
  // =========================
  function setupTabs(tabContainerId, betPanelId, autoPanelId) {
    const tabs = document.querySelectorAll(`#${tabContainerId} .bet-tab`);
    const betPanel = document.getElementById(betPanelId);
    const autoPanel = document.getElementById(autoPanelId);

    autoPanel.style.display = "none";

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => t.classList.remove("active"));
        tab.classList.add("active");

        if (tab.dataset.tab === "bet") {
          autoPanel.style.display = "none";
        } else if (tab.dataset.tab === "auto") {
          autoPanel.style.display = "flex";
        }
      });
    });
  }

  // Initialize tabs
  setupTabs(betTabs1, betPanel1, autoPanel1);
  setupTabs(betTabs2, betPanel2, autoPanel2);

  // Clear auto input buttons
  document.getElementById("clearAutoInput1").addEventListener("click", () => {
    document.getElementById("autoInputMultiplier1").value = "";
  });
  document.getElementById("clearAutoInput2").addEventListener("click", () => {
    document.getElementById("autoInputMultiplier2").value = "";
  });

  function setupBetPanel(panelId) {
    const panel = document.getElementById(panelId);

    const input = panel.querySelector(".bet-amount-input");
    const plusBtn = panel.querySelector("#plusBtn" + panelId.slice(-1));
    const minusBtn = panel.querySelector("#minusBtn" + panelId.slice(-1));
    const betSpan = panel.querySelector('[id^="betAmountSpan"]');
    const quickBtns = panel.querySelectorAll(".q-amt");

    const increment = 10; // 🔥 increment/decrement by 10

    // Update BET button text
    function updateBetText() {
      const value = parseFloat(input.value || 0).toFixed(2);
      betSpan.textContent = `${value} INR`;
    }

    // + button
    plusBtn.addEventListener("click", () => {
      input.value = (parseFloat(input.value || 0) + increment).toFixed(2);
      updateBetAmounts();
      updateBetText();
    });

    // - button
    minusBtn.addEventListener("click", () => {
      input.value = Math.max(
        0,
        parseFloat(input.value || 0) - increment,
      ).toFixed(2);
      updateBetAmounts();
      updateBetText();
    });

    // Quick amount buttons
    quickBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        input.value = parseFloat(btn.dataset.value).toFixed(2);
        updateBetAmounts();
        updateBetText();
      });
    });

    // Manual input typing
    input.addEventListener("input", () => {
      updateBetText();
      updateBetAmounts();
    });

    // Initial sync
    updateBetText();
  }

  // Initialize both panels
  setupBetPanel("betPanel1");
  setupBetPanel("betPanel2");

  // =========================
  // 3. Audio Control Functions
  // =========================

  btnBackgroundAudio.classList.remove("active");
  btnPlaneStartAudio.classList.remove("active");
  btnPlaneCrashAudio.classList.remove("active");

  let audioUnlocked = false;

  function unlockAudio() {
    if (audioUnlocked) return;

    backgroundAudio.muted = false;
    planeStartAudio.muted = false;
    planeCrashAudio.muted = false;

    backgroundAudio.play().catch(() => {});
    planeStartAudio.play().catch(() => {});
    planeCrashAudio.play().catch(() => {});

    audioUnlocked = true;
  }

  // unlock on ANY click
  document.addEventListener("click", unlockAudio, { once: true });

  //   backgroundAudio.play(); // default
  //   planeStartAudio.play();
  //   planeCrashAudio.play();

  function toggleBackground() {
    btnBackgroundAudio.classList.toggle("active");
    if (!btnBackgroundAudio.classList.contains("active")) {
      backgroundAudio.play();
    } else {
      backgroundAudio.pause();
    }
  }

  function playStartSound() {
    btnPlaneStartAudio.classList.toggle("active");
    if (!btnPlaneStartAudio.classList.contains("active")) {
      planeStartAudio.currentTime = 0;
      planeStartAudio.play();
    }
  }

  function playCrashSound() {
    btnPlaneCrashAudio.classList.toggle("active");
    if (!btnPlaneCrashAudio.classList.contains("active")) {
      planeCrashAudio.currentTime = 0;
      planeCrashAudio.play();
    }
  }

  // Attach audio buttons
  btnBackgroundAudio.addEventListener("click", toggleBackground);
  btnPlaneStartAudio.addEventListener("click", playStartSound);
  btnPlaneCrashAudio.addEventListener("click", playCrashSound);

  // ------------------- HISTORY -------------------
  function addHistory(v) {
    historyData.unshift(v);
    renderHistory();
  }

  function cleanShowAllBet() {
    betList.innerHTML = "";
  }

  function showAllBets() {
    // generate only if empty (IMPORTANT)
    cleanShowAllBet();
    if (betList.children.length === 0) {
      const playerNames = ["Sky", "Lucky", "Pro", "Aviator", "Crash", "Red"];
      const shuffledAvatars = [...avatars].sort(() => 0.5 - Math.random());

      for (let i = 0; i < 25; i++) {
        const avatarSrc = shuffledAvatars[i % shuffledAvatars.length];
        const playerName =
          playerNames[(Math.random() * playerNames.length) | 0] +
          ((Math.random() * 99) | 0);

        betList.innerHTML += `
        <div class="bet-item">
          <span class="bet-col bet-player better">
            <img src="/aviator/avatar/${avatarSrc}" class="bet-avatars"/>
            ${playerName}
          </span>
          <span class="bet-col">${(Math.random() * 2000 + 5).toFixed(2)}</span>
          <span class="bet-col">3.1X</span>
          <span class="bet-col bet-end">${(Math.random() * 5000 + 5).toFixed(
            2,
          )}</span>
        </div>
      `;
      }
    }
  }

  function showPreviousBets() {
    let container = document.querySelector(".previous-round-result");

    if (!container) {
      container = document.createElement("div");
      container.className = "previous-round-result";
      container.innerHTML = `
      <div class="result-text">Round Result</div>
      <div class="result-multiplier" style="color:rgb(145,62,248)">
        ${prevMultiplier.toFixed(2)}x
      </div>
    `;
      bettingSidebar.insertBefore(container, bettingSidebar.children[1]);
    }

    if (container) container.style.display = "block";

    if (betList.children.length === 0) {
      const playerNames = ["Sky", "Lucky", "Pro", "Aviator", "Crash", "Red"];
      const shuffledAvatars = [...avatars].sort(() => 0.5 - Math.random());

      for (let i = 0; i < 25; i++) {
        const avatarSrc = shuffledAvatars[i % shuffledAvatars.length];
        const playerName =
          playerNames[(Math.random() * playerNames.length) | 0] +
          ((Math.random() * 99) | 0);

        betList.innerHTML += `
        <div class="bet-item">
          <span class="bet-col bet-player better">
            <img /aviator/avatar/${avatarSrc}" class="bet-avatars"/>
            ${playerName}
          </span>
          <span class="bet-col">${(Math.random() * 2000 + 5).toFixed(2)}</span>
          <span class="bet-col">3.1X</span>
          <span class="bet-col bet-end">${(Math.random() * 5000 + 5).toFixed(
            2,
          )}</span>
        </div>
      `;
      }
    }
  }

  function showTopWinner() {
    const playerNames = ["Sky", "Lucky", "Pro", "Aviator", "Crash", "Red"];
    const topBetsData = [];

    // ---------------- CREATE FILTER UI ----------------
    const filterDiv = document.createElement("div");
    filterDiv.className = "filterDiv";

    const xBtn = createBtn("X", "xBtn active");
    const winBtn = createBtn("Win", "winBtn");
    const roundsBtn = createBtn("Rounds", "roundsBtn");

    const dayBtn = createBtn("Day", "dayBtn active");
    const monthBtn = createBtn("Month", "monthBtn");
    const yearBtn = createBtn("Year", "yearBtn");

    filterDiv.append(xBtn, winBtn, roundsBtn, dayBtn, monthBtn, yearBtn);
    bettingSidebar.insertBefore(filterDiv, bettingSidebar.children[1]);

    // ---------------- MOCK DATA (30+) ----------------
    const shuffledAvatars = [...avatars].sort(() => 0.5 - Math.random());

    const now = new Date();

    for (let i = 0; i < 40; i++) {
      const avatarSrc = shuffledAvatars[i % shuffledAvatars.length];
      const playerName =
        playerNames[Math.floor(Math.random() * playerNames.length)] +
        Math.floor(Math.random() * 99);

      // Some items match today's date for filtering
      const date = new Date();
      if (i < 5) {
        date.setDate(now.getDate()); // today
      } else if (i < 15) {
        date.setMonth(now.getMonth()); // this month
        date.setDate(Math.floor(Math.random() * 28) + 1);
      } else if (i < 30) {
        date.setFullYear(now.getFullYear()); // this year
        date.setMonth(Math.floor(Math.random() * 12));
        date.setDate(Math.floor(Math.random() * 28) + 1);
      } else {
        // random past date
        date.setDate(now.getDate() - Math.floor(Math.random() * 400));
      }

      topBetsData.push({
        avatarSrc,
        playerName,
        date,
        bet: (Math.random() * 500).toFixed(2),
        win: (Math.random() * 1000000).toFixed(2),
        resultX: (Math.random() * 1000).toFixed(3),
        round: i + 1,
      });
    }

    // ---------------- RENDER FUNCTION ----------------
    function renderTopBets() {
      topBetList.innerHTML = "";

      const activeTypeBtn = xBtn.classList.contains("active")
        ? "x"
        : winBtn.classList.contains("active")
          ? "win"
          : roundsBtn.classList.contains("active")
            ? "rounds"
            : null;

      const activeRangeBtn = dayBtn.classList.contains("active")
        ? "day"
        : monthBtn.classList.contains("active")
          ? "month"
          : yearBtn.classList.contains("active")
            ? "year"
            : null;

      if (!activeTypeBtn || !activeRangeBtn) return;

      const now = new Date();

      topBetsData.forEach((item) => {
        const itemDate = item.date;
        let include = false;

        if (activeRangeBtn === "day") {
          include =
            itemDate.getDate() === now.getDate() &&
            itemDate.getMonth() === now.getMonth() &&
            itemDate.getFullYear() === now.getFullYear();
        } else if (activeRangeBtn === "month") {
          include =
            itemDate.getMonth() === now.getMonth() &&
            itemDate.getFullYear() === now.getFullYear();
        } else if (activeRangeBtn === "year") {
          include = itemDate.getFullYear() === now.getFullYear();
        }

        if (!include) return;

        const formattedDate =
          String(itemDate.getDate()).padStart(2, "0") +
          "." +
          String(itemDate.getMonth() + 1).padStart(2, "0") +
          "." +
          itemDate.getFullYear();

        const formattedTime =
          String(itemDate.getHours()).padStart(2, "0") +
          ":" +
          String(itemDate.getMinutes()).padStart(2, "0");

        let topBetValuesContent = "";

        // ---------------- X BUTTON ----------------
        if (activeTypeBtn === "x") {
          topBetValuesContent = `
            <div class="top-bet-values">
            <div class="value-row">
              <span class="label">Bet INR</span>
              <span class="value">${item.bet}</span>
            </div>
            <div class="value-row">
              <span class="label">Win INR</span>
              <span class="value highlight">${item.win}</span>
            </div>
          </div>
          <div class="top-bet-result">
            <div class="value-row">
              <span class="label">Result</span>
              <span class="value x">${item.resultX}x</span>
            </div>
            <div class="value-row">
              <span class="label">Round max.</span>
              <span class="value x-muted">${item.round}x</span>
            </div>
          </div>
        `;
        }

        // ---------------- WIN BUTTON ----------------
        if (activeTypeBtn === "win") {
          topBetValuesContent = `
          <div class="top-bet-values">
            <div class="value-row">
              <span class="label">Bet INR</span>
              <span class="value">${item.bet}</span>
            </div>
            <div class="value-row">
              <span class="label">Win INR</span>
              <span class="value highlight">${item.win}</span>
            </div>
          </div>
          <div class="top-bet-result">
            <div class="value-row">
              <span class="label">Result</span>
              <span class="value x">${item.resultX}x</span>
            </div>
            <div class="value-row">
              <span class="label">Round max.</span>
              <span class="value x-muted">${item.round}x</span>
            </div>
          </div>
        `;
        }

        // ---------------- ROUNDS BUTTON ----------------
        if (activeTypeBtn === "rounds") {
          const betHeader = document.querySelector(".bet-header");
          const roundHeader = document.querySelector(".round-header");

          if (betHeader) {
            betHeader.style.display = "none";
          }

          if (roundHeader) {
            roundHeader.style.display = "flex";
          }
          // topBetValuesContent = `
          // <div class="top-bet-container">
          //   <span class="value-row">${formattedDate} ${formattedTime}</span>
          //   <span class="value-row">${item.resultX}x</span>
          //   <img src="/aviator/pf-icon.svg" alt="fair protection" style="width:18px; height:18px"/>
          // </div>
          // `;
        }

        // Render the item
        topBetList.innerHTML += `
       <div class="${
         activeTypeBtn !== "rounds" ? "top-bet-item" : "top-bet-item-round"
       }">

          ${
            activeTypeBtn !== "rounds"
              ? `
          <div class="top-bet-header">
            <div class="top-bet-user">
              <img src="/aviator/avatar/${item.avatarSrc}" class="top-bet-avatars"/>
              <div class="top-bet-user-info">
                <span class="player-name">${item.playerName}</span>
                <span class="bet-date">${formattedDate}</span>
              </div>
            </div>
            <div class="top-bet-icons">
              <img src="/aviator/message.svg" alt="chat-icon"/>
              <img src="/aviator/pf-icon.svg" alt="fair protection"/>
            </div>
          </div>
           <div class="top-bet-container">
            ${topBetValuesContent}
          </div>
          `
              : (topBetValuesContent = `
        <div class="top-bet-round">
          <span class="value-row">${formattedDate} ${formattedTime}</span>
          <span class="value-row">${item.resultX}x</span>
          <img src="/aviator/pf-icon.svg" alt="fair protection" style="width:1.5rem; height:1.5rem; border-radius:1.5rem;  padding: 0.25rem;
  background-color: #2c2c2c;"/>
        </div>`)
          }
        </div>
      `;
      });
    }

    // ---------------- BUTTON LOGIC ----------------
    function setExclusiveActive(btn, group) {
      group.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      renderTopBets();
    }

    [dayBtn, monthBtn, yearBtn].forEach((btn) =>
      btn.addEventListener("click", () =>
        setExclusiveActive(btn, [dayBtn, monthBtn, yearBtn]),
      ),
    );

    [xBtn, winBtn, roundsBtn].forEach((btn) =>
      btn.addEventListener("click", () =>
        setExclusiveActive(btn, [xBtn, winBtn, roundsBtn]),
      ),
    );

    renderTopBets();

    // ---------------- HELPER ----------------
    function createBtn(text, className) {
      const btn = document.createElement("button");
      btn.textContent = text;
      btn.className = className;
      return btn;
    }
  }

  /* ---------------- HELPER ---------------- */
  function createBtn(text, className) {
    const btn = document.createElement("button");
    btn.textContent = text;
    btn.className = className;
    return btn;
  }

  function addWinnerToBets() {
    const playerNames = ["Sky", "Lucky", "Pro", "Aviator", "Crash", "Red"];
    const avatar = avatars[Math.floor(Math.random() * avatars.length)];
    const name =
      playerNames[(Math.random() * playerNames.length) | 0] +
      ((Math.random() * 99) | 0);

    const bet = (Math.random() * 2000 + 50).toFixed(2);
    const multiplier = (Math.random() * 3 + 1.5).toFixed(2);
    const win = (bet * multiplier).toFixed(2);

    const winnerRow = document.createElement("div");
    winnerRow.className = "bet-item bet-win";

    winnerRow.innerHTML = `
        <span class="bet-col bet-player better">
          <img src="/aviator/avatar/${avatar}" class="bet-avatars" />
          ${name}
        </span>
        <span class="bet-col">${bet}</span>
        <span class="bet-col">${multiplier}X</span>
        <span class="bet-col bet-end">${win}</span>
      `;

    // 🔀 Insert at a random index in the bet list
    const children = Array.from(betList.children);
    const randomIndex = Math.floor(Math.random() * (children.length + 1));

    if (randomIndex >= children.length) {
      betList.appendChild(winnerRow);
    } else {
      betList.insertBefore(winnerRow, children[randomIndex]);
    }
  }

  function getMaxVisible() {
    const barWidth = historyBar.getBoundingClientRect().width;
    if (barWidth === 0) return 10;
    const sampleItem = document.createElement("div");
    sampleItem.className = "history-item mult-blue";
    sampleItem.style.visibility = "hidden";
    sampleItem.style.position = "absolute";
    sampleItem.textContent = "0.00x";
    historyBar.appendChild(sampleItem);
    const itemWidth = sampleItem.offsetWidth + 10;
    historyBar.removeChild(sampleItem);
    return Math.floor(barWidth / itemWidth);
  }

  function renderHistory() {
    historyBar.innerHTML = "";
    const MAX_VISIBLE = getMaxVisible();
    const visibleItems = isExpanded
      ? historyData
      : historyData.slice(0, MAX_VISIBLE);

    visibleItems.forEach((v) => {
      const d = document.createElement("div");
      d.className = `history-item ${v > 10 ? "mult-orange" : v > 2 ? "mult-purple" : "mult-blue"}`;
      d.textContent = v.toFixed(2) + "x";
      historyBar.appendChild(d);
    });

    historyMore.style.display =
      !isExpanded && historyData.length > visibleItems.length
        ? "inline-flex"
        : "none";
    historyClose.style.display = isExpanded ? "inline-flex" : "none";
  }

  historyMore.onclick = () => {
    isExpanded = true;
    historyWrapper.classList.add("expanded");
    renderHistory();
  };
  historyClose.onclick = () => {
    isExpanded = false;
    historyWrapper.classList.remove("expanded");
    setTimeout(renderHistory, 50);
  };

  // ------------------- AVATARS -------------------
  function initAvatars() {
    const selectedAvatars = avatars.sort(() => 0.5 - Math.random()).slice(0, 3);
    selectedAvatars.forEach((src) => {
      const img = document.createElement("img");
      img.src = `/aviator/avatar/${src}`;
      avatarsContainer.appendChild(img);
      avatarsContainerSidebar.appendChild(img.cloneNode(true));
    });
  }
  initAvatars();

  // ------------------- RESIZE -------------------
  function resize() {
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width;
    canvas.height = rect.height;
    renderHistory();
    updatePlaneSize();
  }
  window.addEventListener("resize", resize);
  resize();

  // ------------------- STATE MANAGEMENT -------------------
  function setGameState(state) {
    gameState = state;
    renderActionButtons();
  }

  // ------------------- ACTION BUTTONS -------------------
  function renderActionButtons() {
    renderButton(actionBtn1, bet1);
    renderButton(actionBtn2, bet2);
  }

  /*************************
   * RENDER BUTTON
   *************************/
  function renderButton(btn, bet) {
    if (bet.pending) {
      btn.innerHTML = `CANCEL <small style="display:block; font-size:10px">Waiting for next round</small>`;
      btn.style.background = "#cb011a";
      btn.style.border = "solid 1px #ff7171";
      btn.classList.add("active");
      return;
    }

    if (!bet.placed) {
      btn.innerHTML = `Bet <span>${bet.amount.toFixed(2)} INR</span>`;
      btn.style.background = "#28a909"; // Green
      btn.style.border = "solid 1px #b2f2a3";
      btn.classList.remove("active");
    } else {
      btn.classList.add("active");
      if (gameState === GAME_STATE.LOADING || gameState === GAME_STATE.IDLE) {
        btn.innerHTML = `CANCEL`;
        btn.style.background = "#cb011a"; // Red
        btn.style.border = "solid 1px #ff7171";
      } else if (gameState === GAME_STATE.FLYING && bet.round) {
        // console.log(multiplier);
        const currentWin = (bet.amount * multiplier).toFixed(2);
        btn.innerHTML = `CASH OUT <span id="cashout_btn">${currentWin} INR</span>`;
        btn.style.background = "#d07206"; // Gold/Orange
        btn.style.border = "solid 1px #ffbd71;";
      } else if (gameState === GAME_STATE.FLYING && !bet.round) {
        btn.innerHTML = `Bet <span>${bet.amount.toFixed(2)} INR</span>`;
        btn.style.border = "solid 1px #b2f2a3";
        btn.style.background = "#28a909";
        btn.classList.remove("active");
      }
    }
  }

  /*************************
   * MANUAL BET CLICK
   *************************/
  function handleBetClick(btn, bet, betSide) {
    /* ---------- TOGGLE ONLY CLICKED SIDE ---------- */
    if (betSide === "1") {
      if (gameState === GAME_STATE.LOADING && bet.placed === true) {
        return;
      }
      isBet1Active = !bet.placed ? true : false;
      if (gameState === GAME_STATE.LOADING) {
        directBet(1);
      }
    }

    if (betSide === "2") {
      if (gameState === GAME_STATE.LOADING && bet.placed === true) {
        return;
      }
      isBet2Active = !bet.placed ? true : false;
      if (gameState === GAME_STATE.LOADING) {
        directBet(2);
      }
    }

    // LOADING: Place or Cancel active bet
    if (gameState === GAME_STATE.LOADING || gameState === GAME_STATE.IDLE) {
      if (!bet.placed) {
        bet.placed = true;
        bet.round = true;
      } else {
        bet.placed = false;
        bet.round = false;
      }
    }
    // FLYING/CRASHED: Queue for next round
    else if (
      gameState === GAME_STATE.FLYING ||
      gameState === GAME_STATE.CRASHED
    ) {
      if (!bet.pending && !bet.round) {
        bet.pending = true;
      } else if (bet.pending) {
        bet.pending = false;
      } else if (bet.round && gameState === GAME_STATE.FLYING) {
        // Manual Cash Out
        processCashOut(bet);
        cashoutFunction(betSide);
      }
    }
    renderActionButtons();
  }

  function processCashOut(bet) {
    if (!bet.round) return;

    // Win calculation
    const winAmount = (bet.amount * multiplier).toFixed(2);
    totalWinAmount += parseFloat(winAmount);
    totalWinValue.textContent = totalWinAmount.toFixed(2);

    // Reset current round state
    bet.placed = false;
    bet.round = false;

    // Sound & UI
    renderActionButtons();
  }

  /*************************
   * AUTO BET TOGGLE
   *************************/
  function toggleAutoBet(bet, btn) {
    bet.auto = !bet.auto;
    btn.classList.toggle("active", bet.auto);
  }

  // 1. Auto Cashout Switch (Toggle ON/OFF)
  const btnAutoCashout1 = document.getElementById("btnAutoCashout1");
  btnAutoCashout1.onclick = () => {
    bet1.autoCashoutEnabled = !bet1.autoCashoutEnabled;

    btnAutoCashout1.classList.toggle("active", bet1.autoCashoutEnabled);
  };

  // 2. Auto Cashout Switch 2
  const btnAutoCashout2 = document.getElementById("btnAutoCashout2");
  if (btnAutoCashout2) {
    btnAutoCashout2.onclick = () => {
      bet2.autoCashoutEnabled = !bet2.autoCashoutEnabled;

      btnAutoCashout2.classList.toggle("active", bet2.autoCashoutEnabled);
    };
  }

  /*************************
   * ROUND CONTROL
   *************************/
  function startNewRound() {
    setGameState(GAME_STATE.LOADING);
    multiplier = 1;

    [bet1, bet2].forEach((bet, index) => {
      const inputId = `autoInputMultiplier${index + 1}`;
      const inputEl = document.getElementById(inputId);
      bet.autoCashout = inputEl ? parseFloat(inputEl.value) : 0;

      if (bet.auto || bet.pending) {
        bet.placed = true;
        bet.round = true;
        bet.pending = false;
      }
    });
    renderActionButtons();
  }

  function crashRound() {
    gameState = GAME_STATE.CRASHED;

    [bet1, bet2].forEach((bet) => {
      bet.round = false;
      // Agar pending ya auto nahi hai toh button reset karo
      if (!bet.auto && !bet.pending) {
        bet.placed = false;
      }
    });

    renderActionButtons();
    // History update
    addHistory(multiplier);
  }

  function checkAutoCashout() {
    if (gameState !== GAME_STATE.FLYING) return;

    [bet1, bet2].forEach((bet, index) => {
      if (!bet.round || !bet.autoCashoutEnabled) return;

      const inputId = `autoInputMultiplier${index + 1}`;
      const inputEl = document.getElementById(inputId);
      if (!inputEl) return;

      const target = parseFloat(inputEl.value);
      if (isNaN(target) || target <= 1) return;

      // ✅ USE SERVER MULTIPLIER
      if (serverMultiplier >= target) {
        processCashOut(bet);

        const betSide = index === 0 ? "1" : "2";
        cashoutFunction(betSide);

        renderActionButtons();
      }
    });
  }

  /*************************
   * EVENTS
   *************************/
  actionBtn1.addEventListener("click", function () {
    const betSide = this.dataset.side;
    handleBetClick(this, bet1, betSide);
  });
  actionBtn2.addEventListener("click", function () {
    const betSide = this.dataset.side;
    handleBetClick(this, bet2, betSide);
  });

  autoBtn1.onclick = () => {
    bet1.auto = !bet1.auto;
    autoBtn1.classList.toggle("active", bet1.auto);
  };

  autoBtn2.onclick = () => {
    bet2.auto = !bet2.auto;
    autoBtn2.classList.toggle("active", bet2.auto);
  };

  function startLoading() {
    if (gameState !== GAME_STATE.IDLE) return;
    startNewRound();
    flightT = 0;
    multiplier = 1.0;
    flyX = 0;
    flyY = 0;
    frame = 0;

    [bet1, bet2].forEach((bet) => {
      if (bet.auto || bet.pending) {
        bet.placed = true;
        bet.round = true;
        bet.pending = false;
      }
    });

    renderActionButtons();

    multSpanEl.style.display = "none";
    multDisplay.classList.remove("crashed");
    flewAwayEl.style.display = "none";

    showAllBets();
    animatedPlane.style.opacity = 1;

    let progress = 100;
    const t = setInterval(() => {
      progress--;
      loadBar.style.width = progress + "%";
      // timerModal.style.display = "block";

      if (progress > 60 && Math.random() < 0.35)
        totalUsers += Math.floor(Math.random() * 5) + 3;
      else if (progress > 30 && Math.random() < 0.15)
        totalUsers += Math.floor(Math.random() * 2) + 1;

      countText.textContent = totalUsers.toLocaleString();
      countLeftParticipant.textContent = totalUsers.toLocaleString();
      countTotalParticipant.textContent = totalUsers.toLocaleString();

      planeX = startX;
      planeY = getStartY();
      animatedPlane.style.left = planeX + "px";
      animatedPlane.style.top = planeY + "px";

      if (progress <= 0) {
        clearInterval(t);
        startFlight();
      }
    }, 40);
  }

  function startFlight() {
    if (gameState !== GAME_STATE.LOADING) return;

    setGameState(GAME_STATE.FLYING);
    timerModal.style.display = "none";
    multSpanEl.style.display = "block";
    if (btnPlaneStartAudio.classList.contains("active")) planeStartAudio.play();
    startUserDrop();
  }

  function startUserDrop() {
    const dropInterval = setInterval(() => {
      if (gameState !== GAME_STATE.FLYING) {
        clearInterval(dropInterval);
        return;
      }
      if (Math.random() < 0.25) {
        const drop = Math.floor(Math.random() * 3) + 1;
        totalUsers = Math.max(0, totalUsers - drop);

        const winIncrease = Math.random() * 500 + 50;
        totalWinAmount += winIncrease;
        totalWinValue.textContent = totalWinAmount.toFixed(2);

        countText.textContent = totalUsers.toLocaleString();
        countLeftParticipant.textContent = totalUsers.toLocaleString();

        const statsLoader = document.querySelector(".bet-stats-loading-bar");
        if (statsLoader)
          statsLoader.style.width =
            Math.min((totalWinAmount / 100000) * 100, 100) + "%";

        addWinnerToBets();
      }
    }, 300);
  }

  function resetGame() {
    setGameState(GAME_STATE.IDLE);
    // actionBtn1.innerHTML = `Bet <span>${bet1.amount.toFixed(2)} INR</span>`;
    // actionBtn2.innerHTML = `Bet <span>${bet2.amount.toFixed(2)} INR</span>`;
    // actionBtn1.style.background = "#28a909";
    // actionBtn2.style.background = "#28a909";
    animatedPlane.style.opacity = 0;
    loadBar.style.width = "0%";
    totalWinValue.textContent = "0.00";
    flyX = flyY = flightT = frame = 0;
    const statsLoader = document.querySelector(".bet-stats-loading-bar");
    if (statsLoader) statsLoader.style.width = "0%";
    // setTimeout(startLoading, 1800);
  }

  function loop() {
    frame++;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // ---------- BACKGROUND ----------
    ctx.fillStyle = "#0a0a0c";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // ---------- DISCO EFFECT ----------
    const strapCount = 30;
    const radius = Math.max(canvas.width, canvas.height) * 2;

    ctx.save();
    ctx.translate(0, canvas.height);
    ctx.rotate(discoRotation);

    for (let i = 0; i < strapCount; i++) {
      ctx.beginPath();
      ctx.moveTo(0, 0);
      const angleStep = (Math.PI * 2) / strapCount;
      ctx.arc(0, 0, radius, i * angleStep, (i + 0.5) * angleStep);
      ctx.lineTo(0, 0);
      ctx.fillStyle = `hsla(${(discoHue + i * 15) % 360},60%,15%,0.2)`;
      ctx.fill();
    }

    ctx.restore();
    discoRotation -= 0.0025;
    discoHue += 0.8;

    // ---------- PLANE MOVEMENT ----------
    if (gameState === GAME_STATE.FLYING || gameState === GAME_STATE.CRASHED) {
      const pw = planeWidth;
      const ph = planeHeight;

      const surfaceY = getStartY();
      const baseX = canvas.width - pw;

      flightT = Math.min(flightT + 0.0015 * (1 + multiplier * 0.02), 1);

      let targetX, targetY;

      // ---------- TAKEOFF + LOOP ----------
      if (flightT < 0.75) {
        const t = flightT / 0.75;
        targetX = lerp(startX, baseX * 0.7, t);
        targetY = lerp(surfaceY, 0, t); // 🔥 full height
        phaseStartFrame = frame;
      } else {
        const loopProgress = ((frame - phaseStartFrame) * 0.004) % 2;
        const tLoop = loopProgress > 1 ? 2 - loopProgress : loopProgress;
        targetX = lerp(baseX * 0.7, baseX, tLoop);
        targetY = lerp(0, surfaceY, tLoop);
      }

      multSpanEl.style.background = "rgba(52, 135, 255, 0)";
      multSpanEl.style.boxShadow = "rgba(52, 135, 255, 0) 0px 0px 30px 30px";

      // ---------- MULTIPLIER ----------
      if (gameState === GAME_STATE.FLYING) {
        // ✅ ONLY smooth towards server value
        multiplier += (serverMultiplier - multiplier) * 0.2;
        prevMultiplier = multiplier;

        multSpanEl.textContent = multiplier.toFixed(2) + "x";

        if (multiplier < 2) {
          multSpanEl.style.background = "rgba(52, 135, 255, 0.3)";
          multSpanEl.style.boxShadow =
            "rgba(52, 135, 255, 0.3) 0px 0px 30px 30px";
        } else if (multiplier < 10) {
          multSpanEl.style.background = "rgba(145, 62, 248, 0.3)";
          multSpanEl.style.boxShadow =
            "rgba(145, 62, 248, 0.3) 0px 0px 30px 30px";
        } else {
          multSpanEl.style.background = "rgba(192, 23, 180, 0.3)";
          multSpanEl.style.boxShadow =
            "rgba(192, 23, 180, 0.3) 0px 0px 30px 30px";
        }

        renderActionButtons();
        checkAutoCashout();

        // console.log(crashPoint, "crashPoint");

        // if (multiplier >= crashPoint) {
        //   crashRound();
        //   multDisplay.classList.add("crashed");

        //   if (btnPlaneCrashAudio.classList.contains("active")) {
        //     planeCrashAudio.currentTime = 0;
        //     planeCrashAudio.play();
        //   }

        //   flewAwayEl.style.display = "block";
        //   addHistory(crashPoint);
        // }
      } else {
        // ---------- CRASH FLY AWAY ----------
        flyX += 35;
        flyY -= 25;
        targetX += flyX;
        targetY += flyY;
      }

      // ---------- CLAMP ----------
      let finalX, finalY;

      if (gameState === GAME_STATE.FLYING) {
        finalX = clamp(targetX, -pw * 0.25, canvas.width);
        finalY = clamp(targetY, 0, surfaceY);
      } else {
        finalX = targetX;
        finalY = targetY;
      }

      planeX = finalX;
      planeY = finalY;

      animatedPlane.style.left = planeX + "px";
      animatedPlane.style.top = planeY + "px";

      // ---------- RED TAIL ----------
      if (
        gameState === GAME_STATE.FLYING &&
        !btnPlaneCrashAudio.classList.contains("active")
      ) {
        document.getElementById("animatedPlane").style.display = "block";

        const tailX = finalX + pw * 0.14;
        const tailY = finalY + ph - 6;

        ctx.beginPath();
        ctx.moveTo(0, canvas.height);
        ctx.quadraticCurveTo(tailX * 0.45, canvas.height, tailX, tailY);

        ctx.strokeStyle = "#e50539";
        ctx.lineWidth = Math.max(2, canvas.height * 0.005);
        ctx.stroke();

        ctx.lineTo(tailX, canvas.height);
        ctx.lineTo(0, canvas.height);

        const gradient = ctx.createLinearGradient(0, tailY, 0, canvas.height);
        gradient.addColorStop(0, "rgb(229,5,57)");
        gradient.addColorStop(1, "rgba(229,5,57,0)");

        ctx.fillStyle = gradient;
        ctx.fill();
      } else {
        document.getElementById("animatedPlane").style.display = "none";
      }

      // ---------- RESET ----------
      if (
        gameState === GAME_STATE.CRASHED &&
        (planeX > canvas.width + 300 || planeY < -300)
      ) {
        resetGame();
      }
    }

    requestAnimationFrame(loop);
  }

  // ------------------- START -------------------
  renderHistory();
  // startLoading();
  loop();

  function isGameStarted() {
    return serverGameState === GAME_STATE.FLYING;
  }

  // user data is here
  let userPhone = "";
  let userBetHistory = [];

  // ------ Api Call ------- //
  const fetchUser = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(base_url + "/api/webapi/userData", {
        headers: {
          Authorization: token,
        },
      });

      if (response.data.status === true) {
        userData = response.data.data;
        userBetHistory = response.data.betHistoryData || [];
        userPhone = userData.phone;

        addBetHistoryRow(userBetHistory);

        document.getElementById("user_balance").innerText = parseFloat(
          userData.money,
        );

        document.getElementById("user_id").innerText = parseFloat(
          userData.id_user,
        );
      }
    } catch (error) {
      console.log("User fetch error:", error);
    }
  };
  fetchUser();

  /// ----- alert function ------- ///
  function alertBoxFunction(message, className) {
    const alertBox = document.getElementById("alertBox");
    const alertMessage = document.getElementById("alertMessage");

    alertMessage.innerText = message;
    alertBox.classList.add(className);
    alertBox.style.display = "flex";

    setTimeout(() => {
      alertBox.style.display = "none";
    }, 3000);
  }

  /// ---------------- Dirrect Bet ---------------- ///
  function directBet(betSide) {
    if (gameState !== GAME_STATE.LOADING) {
      alertBoxFunction(
        "Bets can only be placed during the loading phase.",
        "error",
      );
      return;
    }
    if (betSide === 1) {
      socket.emit("place_bet", {
        amount: betAmount1.value,
        betSide: 1,
      });
    }
    if (betSide === 2) {
      socket.emit("place_bet", {
        amount: betAmount2.value,
        betSide: 2,
      });
    }
  }

  // ------- Socket Part Start -------- //

  socket.on("sync_state", (state) => {
    serverGameState = state.gameState;
    serverMultiplier = state.multiplier;

    gameState = serverGameState;
    gameId = state.gameid;

    if (serverGameState === GAME_STATE.LOADING) {
      timerModal.style.display = "block";
      startLoading();
      showAllBets();
    }

    if (serverGameState === GAME_STATE.FLYING) {
      showAllBets();
      startUserDrop();
      multSpanEl.style.display = "block";
      timerModal.style.display = "none";
      if (btnPlaneStartAudio.classList.contains("active"))
        planeStartAudio.play();
    }
  });

  socket.on("round_loading", () => {
    timerModal.style.display = "block";
    serverGameState = GAME_STATE.LOADING;
    startLoading();
    serverMultiplier = 1.0;

    if ((isBet1Active === true && bet1.placed === true) || bet1.auto) {
      socket.emit("place_bet", {
        amount: betAmount1.value,
        betSide: 1,
      });
    }

    if ((isBet2Active === true && bet2.placed === true) || bet2.auto) {
      socket.emit("place_bet", {
        amount: betAmount2.value,
        betSide: 2,
      });
    }
  });

  socket.on("round_start", (data) => {
    gameId = data.gameid;

    if (isBet1Placed === true) {
      bet1.placed = true;
    }

    if (isBet2Placed === true) {
      bet2.placed = true;
    }

    if (isBet1Placed === false) {
      bet1.placed = false;
    }

    if (isBet2Placed === false) {
      bet2.placed = false;
    }

    isBet1Active = false;
    isBet2Active = false;

    if (isBet1Active === true && bet1.placed === false && bet1.auto === false) {
      bet1.placed = false;
      alertBoxFunction("Someting went wrong..", "error");
    }

    if (isBet2Active === true && bet2.placed === false && bet2.auto === false) {
      bet2.placed = false;
      alertBoxFunction("Someting went wrong..", "error");
    }

    serverGameState = GAME_STATE.FLYING;
    gameState = GAME_STATE.FLYING;
    startLoading();
    startUserDrop();

    multSpanEl.style.display = "block";
    timerModal.style.display = "none";

    if (btnPlaneStartAudio.classList.contains("active")) {
      planeStartAudio.play();
    }
  });

  socket.on("multiplier_update", (value) => {
    serverMultiplier = parseFloat(value);
  });

  socket.on("round_crash", (value) => {
    actionBtn1.innerHTML = `Bet <span>${bet1.amount.toFixed(2)} INR</span>`;
    actionBtn2.innerHTML = `Bet <span>${bet2.amount.toFixed(2)} INR</span>`;
    actionBtn1.style.background = "#28a909";
    actionBtn2.style.background = "#28a909";
    actionBtn1.style.border = "solid 1px #b2f2a3";
    actionBtn2.style.border = "solid 1px #b2f2a3";

    serverMultiplier = parseFloat(value);
    multSpanEl.textContent = serverMultiplier.toFixed(2) + "x";
    serverGameState = GAME_STATE.CRASHED;
    gameState = GAME_STATE.CRASHED;

    multDisplay.classList.add("crashed");
    flewAwayEl.style.display = "block";

    if (btnPlaneCrashAudio.classList.contains("active")) {
      planeCrashAudio.currentTime = 0;
      planeCrashAudio.play();
    }

    crashRound();

    isBet1Placed = false;
    isBet2Placed = false;
  });

  socket.on("crash_history", (history) => {
    historyData.length = 0;

    history.forEach((item) => {
      const val = parseFloat(item.result);
      if (!isNaN(val)) {
        historyData.push(val);
      }
    });

    renderHistory();
  });

  socket.on("bet_success", (data) => {
    if (data.betSide === 1) {
      isBet1Placed = true;
    }

    if (data.betSide === 2) {
      isBet2Placed = true;
    }

    fetchUser();
  });

  socket.on("bet_error", (data) => {
    alertBoxFunction(data.message, "error");
    fetchUser();
  });

  socket.on("cashout_success", (data) => {
    alertBoxFunction(data.message, "success");
    fetchUser();
  });

  socket.on("cashout_error", (data) => {
    alertBoxFunction(data.message, "error");
    fetchUser();
  });

  socket.on("disconnect", () => {
    alertBoxFunction("Disconnected from server", "");
    isBet1Active = false;
    isBet2Active = false;
  });

  // ------- cashout function ------- //
  function cashoutFunction(betSide) {
    if (!GAME_STATE.FLYING) return;
    if (isBet1Placed === false && betSide == 1) return;
    if (isBet2Placed === false && betSide == 2) return;
    socket.emit("cashout", { betSide, gameid: gameId });
  }

  const myBetList = document.getElementById("myBetList");
  const myBetListBtn = document.getElementById("myBetListBtn");
  const modalOverlay = document.querySelector(".modal-overlay");
  const modal = document.querySelector(".modal");
  const closeBtn = document.querySelector(".close");

  myBetListBtn.addEventListener("click", () => {
    modalOverlay.classList.add("active");
  });

  closeBtn.addEventListener("click", () => {
    modalOverlay.classList.remove("active");
  });
  modalOverlay.addEventListener("click", () => {
    modalOverlay.classList.remove("active");
  });

  function addBetHistoryRow(betData) {
    betData.forEach((bet) => {
      const row = document.createElement("div");
      row.className = "bet-row" + (bet.winAmount ? " win" : "");

      row.innerHTML = `
    <div class="date">${new Date(bet.created_at).toLocaleTimeString()}<br>${new Date(bet.created_at).toLocaleDateString()}</div>
    <div>${parseFloat(bet.amount).toFixed(2)}</div>
    <div>
      <span class="multiplier ${bet.cashout_multiplier > 2 ? "purple" : "blue"}">${parseFloat(bet.cashout_multiplier).toFixed(2)}x</span>
    </div>
    <div class="cashout">${bet.winAmount ? parseFloat(bet.winAmount).toFixed(2) : ""}</div>
    <div class="cashout"><img src="/aviator/shield.svg" alt="shield-icon" style="width:1rem;height:1rem"/> <img src="/aviator/chat.svg" alt="chat-icon"/></div>
  `;

      myBetList.appendChild(row);
    });
  }

  const howToPlayBtn = document.getElementById("howToPlayBtn");
  const howToPlayOverlay = document.getElementById("howToPlayOverlay");

  // OPEN example
  howToPlayBtn.onclick = () => {
    howToPlayOverlay.classList.add("active");
  };

  // CLOSE on outside click
  howToPlayOverlay.addEventListener("click", (e) => {
    if (e.target === howToPlayOverlay) {
      howToPlayOverlay.classList.remove("active");
    }
  });

  const freeBetBtn = document.getElementById("freeBetBtn");
  const freeBetModalOverlay = document.getElementById("freeBetOverlay");
  const closeFreeBet = document.getElementById("closeFreeBet");

  // OPEN (example button)
  freeBetBtn.addEventListener("click", () => {
    freeBetModalOverlay.classList.add("active");
  });

  freeBetModalOverlay.onclick = () => {
    freeBetModalOverlay.classList.remove("active");
  };
  closeFreeBet.onclick = () => {
    freeBetModalOverlay.classList.remove("active");
  };

  const gameLimitBtn = document.getElementById("gameLimitBtn");
  const gameLimitOverlay = document.getElementById("gameLimitOverlay");
  const closeGameLimit = document.getElementById("closeGameLimit");

  // OPEN (example)
  gameLimitBtn.onclick = () => {
    gameLimitOverlay.classList.add("active");
  };

  gameLimitOverlay.onclick = () => {
    gameLimitOverlay.classList.remove("active");
  };

  closeGameLimit.onclick = () => {
    gameLimitOverlay.classList.remove("active");
  };

  const provablyFairOverlayBtn = document.getElementById(
    "provablyFairOverlayBtn",
  );
  const provablyFairOverlay = document.getElementById("provablyFairOverlay");
  const closeProvably = document.getElementById("closeProvably");

  // OPEN example
  provablyFairOverlayBtn.onclick = () => {
    provablyFairOverlay.classList.add("active");
  };

  closeProvably.onclick = () => {
    provablyFairOverlay.classList.remove("active");
  };

  const radioRows = document.querySelectorAll(".radio-row");

  radioRows.forEach((row) => {
    const radio = row.querySelector(".radio-dot");

    row.addEventListener("click", () => {
      // remove active from all
      radioRows.forEach((r) => r.classList.remove("active"));

      // add active to clicked
      row.classList.add("active");

      // check the radio
      radio.checked = true;

      // enable / disable seed boxes
      radioRows.forEach((r) => {
        const box = r.querySelector(".seed-box");
        if (box) box.classList.add("disabled");
      });

      const activeBox = row.querySelector(".seed-box");
      if (activeBox) activeBox.classList.remove("disabled");
    });
  });

  document.querySelectorAll(".copy").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();

      const text = btn.previousElementSibling.textContent
        .replace("Current:", "")
        .trim();

      navigator.clipboard.writeText(text);

      btn.textContent = "✅";
      setTimeout(() => (btn.textContent = "📋"), 1000);
    });
  });

  const gameRulesBtn = document.getElementById("gameRulesBtn");
  const gameRulesOverlay = document.getElementById("gameRulesOverlay");
  const closeGameRules = document.getElementById("closeGameRules");

  gameRulesBtn.onclick = () => {
    gameRulesOverlay.classList.add("active");
  };

  closeGameRules.onclick = () => {
    gameRulesOverlay.classList.remove("active");
  };

  const TOTAL_AVATARS = 72;
  const avatarGrid = document.getElementById("avatarGrid");

  const openAvatarModalBtn = document.getElementById("openAvatarModal");
  openAvatarModalBtn.onclick = () => openAvatarModal();

  function openAvatarModal() {
    document.getElementById("avatarModal").classList.add("active");
  }

  const closeAvatarBet = document.getElementById("closeAvatarBet");
  closeAvatarBet.onclick = () => closeModal();

  function closeModal() {
    document.getElementById("avatarModal").classList.remove("active");
  }

  function selectAvatar(src) {
    document.getElementById("currentAvatar").src = src;
    localStorage.setItem("selectedAvatar", src); // optional
    closeModal();
  }

  // Generate avatars dynamically
  function loadAvatars() {
    for (let i = 1; i <= TOTAL_AVATARS; i++) {
      const img = document.createElement("img");
      img.src = `/aviator/avatar/av-${i}.png`;
      img.onclick = () => selectAvatar(img.src);
      avatarGrid.appendChild(img);
    }
  }

  // Load saved avatar + avatars on page load
  window.onload = () => {
    const saved = localStorage.getItem("selectedAvatar");
    if (saved) {
      document.getElementById("currentAvatar").src = saved;
    }
    loadAvatars();
  };
}
